module.exports = __webpack_public_path__ + "img/img_2.0884f385.png";